"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Skeleton as Skeleton$1 } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/Skeleton.css';const root = "_root_1y8mw_2";
const SkeletonStyles = {
  root
};
const _Skeleton = forwardRef((props, ref) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    Skeleton$1,
    {
      ...rest,
      radius: "md",
      ref,
      classNames: SkeletonStyles,
      className
    }
  );
});
_Skeleton.displayName = "Skeleton";
const Skeleton = sharedHandler(_Skeleton);
Skeleton.displayName = _Skeleton.displayName;
export {
  SkeletonStyles as S,
  Skeleton as default
};
